import { type FullBoilerRoom } from "@eisox/api/core-api";

export function findNearestAncestor(
  boilerRooms: FullBoilerRoom[],
  currentBoilerRoom: FullBoilerRoom,
): FullBoilerRoom | null {
  if (!currentBoilerRoom.parentId) {
    return currentBoilerRoom; // Reached the topmost ancestor
  }
  const parentBoilerRoom = boilerRooms.find(room =>
    room.heatingNetworks?.some(hn => hn.id === currentBoilerRoom.parentId),
  );
  if (!parentBoilerRoom) {
    return currentBoilerRoom; // If parent BoilerRoom not found, return current BoilerRoom
  }
  return parentBoilerRoom;
}

export const findFarthestAncestor = (boilerRoomId: string, boilerRooms: FullBoilerRoom[]): FullBoilerRoom | null => {
  const currentBoilerRoom = boilerRooms.find(b => b.id === boilerRoomId);
  if (!currentBoilerRoom) return null;

  if (!currentBoilerRoom.parentId) return null;

  const parentBoilerRoom = boilerRooms.find(b => b.heatingNetworks?.some(hn => hn.id === currentBoilerRoom.parentId));
  if (!parentBoilerRoom) return null;

  return findFarthestAncestor(parentBoilerRoom.id, boilerRooms) ?? parentBoilerRoom;
};

/** The boiler room the right-column selector lists first, so entry points land on it. */
export const getFirstSelectableBoilerRoom = <T extends Pick<FullBoilerRoom, "parentId">>(
  boilerRooms: T[],
): T | undefined => boilerRooms.find(b => b.parentId === undefined);

export const formatCalorieConsoDisplay = (kwh: number): { c: string; unit: "kWh" | "MWh" } => {
  if (kwh > 1000) {
    const mwh = kwh / 1000;
    const c = String(parseFloat(mwh.toFixed(4)));
    return { c, unit: "MWh" };
  }
  return { c: kwh.toFixed(1), unit: "kWh" };
};
